import { useEffect, useState } from 'react'
import { useUser } from '@mfox/shared/contexts/UserContext'
import { subscribeToXpAwarded } from '@mfox/shared/lib/xp/xpEvents'
import { Toast } from '@mfox/shared/ui/Toast'
import './ToastHost.css'

interface ActiveToast {
  id: number
  message: string
}

const DISMISS_AFTER_MS = 3000

/**
 * XP notices, in the page's flow under the top bar: one pushes the page down instead of covering it, then goes. The
 * app frame and the test runner each place one. The live region stays in the DOM while empty, so a screen reader
 * hears each notice once, as it arrives.
 */
export function ToastHost() {
  const { currentUser } = useUser()
  const [toasts, setToasts] = useState<ActiveToast[]>([])

  useEffect(() => {
    let nextId = 0
    const timeouts: ReturnType<typeof setTimeout>[] = []
    const unsubscribe = subscribeToXpAwarded(({ userId, awarded }) => {
      if (userId !== currentUser?.email) return
      const id = nextId++
      setToasts((prev) => [...prev, { id, message: `+${awarded.xp} XP · ${awarded.label}` }])
      const timeoutId = setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id))
      }, DISMISS_AFTER_MS)
      timeouts.push(timeoutId)
    })
    return () => {
      unsubscribe()
      timeouts.forEach(clearTimeout)
      setToasts([])
    }
  }, [currentUser?.email])

  return (
    <div className="toast-host" role="status">
      {toasts.map((toast) => (
        <Toast key={toast.id} message={toast.message} />
      ))}
    </div>
  )
}
